export default __webpack_public_path__ + "static/media/blood.64489d17.svg";